import { IPreference } from './IPreference'

export const GET_PREFERENCES_LOADING = 'GET_PREFERENCES_LOADING'
export const GET_PREFERENCES_SUCCESS = 'GET_PREFERENCES_SUCCESS'
export const GET_PREFERENCES_FAILURE = 'GET_PREFERENCES_FAILURE'

export const SET_PREFERENCE_LOADING = 'SET_PREFERENCE_LOADING'
export const SET_PREFERENCE_SUCCESS = 'SET_PREFERENCE_SUCCESS'
export const SET_PREFERENCE_FAILURE = 'SET_PREFERENCE_FAILURE'

interface IGetPreferencesLoading {
  type: typeof GET_PREFERENCES_LOADING
}

interface IGetPreferencesSuccess {
  type: typeof GET_PREFERENCES_SUCCESS
  payload: { preferences: IPreference }
}

interface IGetPreferencesFailure {
  type: typeof GET_PREFERENCES_FAILURE
  payload: { error: string }
}

interface ISetPreferencesSuccess {
  type: typeof GET_PREFERENCES_SUCCESS
  payload: {
    preferences: IPreference
  }
}

interface ISetPreferencesFailure {
  type: typeof SET_PREFERENCE_FAILURE
  payload: {
    error: string
  }
}

interface ISetPreferencesLoading {
  type: typeof SET_PREFERENCE_LOADING
}

export type TActionTypes =
  | IGetPreferencesSuccess
  | IGetPreferencesFailure
  | IGetPreferencesLoading
  | ISetPreferencesLoading
  | ISetPreferencesSuccess
  | ISetPreferencesFailure
